import { useEffect, useState } from "react";
import { HandHeart, Save, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import api from "@/lib/api";
import { toast } from "sonner";

export function ChatSettingsCard({ streamId }) {
  const [f, setF] = useState({ giving_label: "", giving_url: "", chat_welcome: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/streams/${streamId}/chat-settings`).then((r) => setF(r.data)).catch(() => {});
  }, [streamId]);

  const save = async () => {
    setSaving(true);
    try { const r = await api.put(`/streams/${streamId}/chat-settings`, f); setF(r.data); toast.success("Chat settings saved for all your streams"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save"); } finally { setSaving(false); }
  };

  return (
    <div className="bg-card border border-gray-800 rounded-2xl p-6 space-y-4" data-testid="chat-settings-card">
      <div>
        <h3 className="font-display text-lg font-semibold flex items-center gap-2"><HandHeart className="h-5 w-5 text-amber-400" /> Giving link & welcome note</h3>
        <p className="text-sm text-gray-400 mt-1">Pinned at the top of the chat on every one of your streams, even while offline.</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <div className="space-y-1.5">
          <Label className="text-gray-300 text-sm">Button text</Label>
          <Input data-testid="giving-label-input" value={f.giving_label} maxLength={40} onChange={(e) => setF({ ...f, giving_label: e.target.value })} placeholder="Give Online" className="bg-gray-950 border-gray-800" />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-gray-300 text-sm">Giving link</Label>
          <Input data-testid="giving-url-input" value={f.giving_url} onChange={(e) => setF({ ...f, giving_url: e.target.value })} placeholder="https://yourchurch.org/give" className="bg-gray-950 border-gray-800" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label className="text-gray-300 text-sm">Welcome note <span className="text-gray-500 font-normal">(optional)</span></Label>
        <Textarea data-testid="chat-welcome-input" value={f.chat_welcome} maxLength={280} rows={2} onChange={(e) => setF({ ...f, chat_welcome: e.target.value })} placeholder="Welcome! We're glad you're worshipping with us today." className="bg-gray-950 border-gray-800 resize-none" />
      </div>
      <div className="flex justify-end">
        <button data-testid="save-chat-settings" onClick={save} disabled={saving} className="gold-gradient text-black font-semibold px-4 py-2 rounded-lg flex items-center gap-2 disabled:opacity-60">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save
        </button>
      </div>
    </div>
  );
}
